import { releaseNotes } from 'enums/releaseNotes'
import ReleaseInfo from './ReleaseInfo'
import { VStack } from '@chakra-ui/react'
import ManagerLayout from 'components/ManagerLayout'

const ReleaseNotes = () => {
    return (
        <ManagerLayout>
            <VStack spacing={4} w="full">
                {
                    releaseNotes.map(note => <ReleaseInfo note={note} />)
                }
            </VStack>
        </ManagerLayout>
    )
}

export default ReleaseNotes